import { Navigate, useLocation } from 'react-router-dom';
import { useStaffAuth } from '@/contexts/StaffAuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Wraps any staff route. Sends the user to /staff/login if they're not signed
 * in, preserving the originally-requested path so we can bounce them back.
 */
export function RequireStaffAuth({ children }) {
  const { user, loading } = useStaffAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-600" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/staff/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return children;
}
